// Helper functions for route processing
import React from 'react'

/**
 * Create Route component from route configuration
 * @param {object} routeConfig - Route configuration
 * @param {string} routeConfig.path - Route path
 * @param {React.Component} routeConfig.element - Route element
 * @param {object} routeConfig.props - Additional props to pass to element (optional)
 * @returns {React.Element} Route component
 */
export const createRouteFromConfig = (routeConfig) => {
	const { path, element, props } = routeConfig

	// Clone element with additional props if provided
	let finalElement = element
	if (props && Object.keys(props).length > 0) {
		finalElement = React.cloneElement(element, { ...element.props, ...props })
	}

	return {
		path,
		element: finalElement,
	}
}

/**
 * Process route configurations and return Route components
 * @param {Array} routeConfigs - Array of route configurations
 * @returns {Array} Array of Route components
 */
export const processRouteConfigs = (routeConfigs) => {
	if (!Array.isArray(routeConfigs)) {
		return []
	}

	return routeConfigs
		.map(config => createRouteFromConfig(config))
		.filter(route => route !== null)
}
